import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface DataQualityPromptStore {
  /**
   * Per-user opt-out from the Account page, keyed by user id so one account's
   * choice never leaks to another on a shared browser. The brand-level rollout
   * stays backend-controlled via Brand.dataQualityPrompt.
   */
  disabledUserIds: number[];
  setUserPromptDisabled: (userId: number, isPromptDisabled: boolean) => void;
}

const useDataQualityPromptStore = create<DataQualityPromptStore>()(
  persist(
    (set) => ({
      disabledUserIds: [],
      setUserPromptDisabled: (userId, isPromptDisabled) =>
        set((state) => ({
          disabledUserIds: isPromptDisabled
            ? [...new Set([...state.disabledUserIds, userId])]
            : state.disabledUserIds.filter((id) => id !== userId)
        }))
    }),
    {
      name: 'dataQualityPromptStore',
      storage: createJSONStorage(() => localStorage)
    }
  )
);

// Getters
export const useIsDataQualityPromptDisabled = (userId: number | undefined) =>
  useDataQualityPromptStore((state) => userId !== undefined && state.disabledUserIds.includes(userId));

// Actions
export const useDataQualityPromptActions = () => {
  const setUserPromptDisabled = useDataQualityPromptStore((state) => state.setUserPromptDisabled);
  return { setUserPromptDisabled };
};
